<div
  class="container-fluid d-flex text-light flex-nowrap flex-column justify-content-center align-items-center c-height 222">
  <div class="custom-max-width slideInUp">
    <div class="d-flex align-items-center flex-wrap">
      <h1 class="display-2 font-2_2rem">
        {{ "Knowledge gate" | translator }}
      </h1>
      <div
        *ngIf="currentOu"
        class="d-flex align-items-center custom-mx-3 capsoul px-4 py-2"
      >
        <span class="capsoul-img-box">
          <img
            *ngIf="checkisImg(currentOu.image_sq); else elseBlock"
            src="{{ staticURL }}{{ currentOu.image_sq }}"
            class="img-fluid p-1 capsoul-img"
          />
          <ng-template #elseBlock>
            <i class="{{ currentOu.image_sq }} p-2 font-1rem"></i>
          </ng-template>
        </span>
        <p
          class="px-2 m-0">
          {{ currentOu.name }}
        </p>
      </div>
    </div>
    <div class="p-inputgroup my-3 pos-rel">
      <span class="pos-abs">
        <i
          *ngIf="!searchQueryObject"
          [routerLink]="'/home'"
          class="pi pi-fw pi-angle-right font-500 font-4"
        ></i>
        <i
          *ngIf="searchQueryObject"
          (click)="gotoAdvanceSearch(searchQueryObject)"
          class="pi pi-fw pi-angle-right font-500 font-4"
        ></i>
      </span>
      <span class="p-input-icon-right w-100">
        <i class="pi pi-search"></i>
        <input
          type="text"
          class="p-inputtext-lg sstarabic w-100 radius-8"
          pInputText
          placeholder="بحث"
          [(ngModel)]="searchText"
          (keydown.enter)="navigateToSearch($event)"
        />
      </span>
    </div>
    <div class="d-flex my-4">
      <span class="btn-css">
        <span
          class="mx-2 font-0_8rem"
          (click)="showItems = !showItems"
          >{{ "Recent searches" | translator }}</span
        >
        <span (click)="showItems = !showItems">
          <img class="" src="../../../../assets/icones-2025/arrow_drop_down.png" alt="loading">
        </span>
      </span>
    </div>
    <div
      *ngIf="showItems && recentsearches.length > 0 && isLoggedIn"
      class="d-flex align-items-center w-100 ovr-flow-hide gap-2 my-2 m-bottom-4"
    >
      <p-chip
        class="pointer"
        *ngFor="let item of recentsearches"
        [label]="item?._id"
        (click)="
          searchText = item?._id;
          navigateToSearch({ target: { value: searchText } })
        "
        styleClass="px-3 white-space-nowrap text-dark text-nowrap"
      ></p-chip>
    </div>
  </div>
</div>
